<!--
 * @Author: wsx
 * @Date: 2022-02-11 15:00:48
 * @LastEditTime: 2022-02-11 17:52:34
 * @LastEditors: Please set LastEditors
 * @Description: 选择器
 * @FilePath: \smart-community\src\components\global\HSelect.vue
-->
<template>
  <div class="HSelect">
    <el-popover
      ref="popoverRef"
      :width="width"
      trigger="click"
      placement="bottom-start"
    >
      <template #reference>
        <el-input v-model="input" readonly :placeholder="placeholder" />
      </template>
      <ul class="h-select-list" v-if="type === 'list'">
        <template v-for="item in data" :key="item[nodeKey]">
          <li
            class="h-select-list-item"
            :class="[currentNode[nodeKey] === item[nodeKey] ? 'selected' : '']"
            @click="currentChange(item)"
          >
            {{ item[props.label] }}
          </li>
        </template>
      </ul>
      <el-tree
        v-else
        style="height:500px;overflow: auto"
        ref="treeSelectRef"
        :data="data"
        :node-key="nodeKey"
        highlight-current
        :props="props"
        @current-change="currentChange"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
      >
      </el-tree>
    </el-popover>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watchEffect,
  ref
} from "vue";
export default defineComponent({
  name: "HSelect",
  components: {},
  props: {
    placeholder: {
      type: String,
      default: "请选择"
    },
    options: {
      type: Object,
      default: () => {
        return {
          label: "label",
          children: "children",
          id: ""
        };
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [Object, String, Number]
    },
    // 下拉列表类型
    type: {
      type: String,
      default: "list" // list 列表；tree 树
    },
    width: {
      type: [Number, String],
      default: 200
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const state = reactive({
      input: "",
      props: {
        label: props.options.label || "label",
        children: props.options.children || "children"
      },
      nodeKey: props.options.id,
      dataSource: [],
      currentNode: {}
    });

    const refData = toRefs(state);
    const popoverRef = ref(null);
    const treeSelectRef = ref(null);

    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data[state.props.label].indexOf(value) !== -1;
    };

    // 当前选中节点变化时触发的事件
    const currentChange = item => {
      state.currentNode = item;
      state.input = state.currentNode[state.props.label];

      if (popoverRef.value) {
        popoverRef.value.hide();
      }
      if (state.nodeKey) {
        emit("update:modelValue", state.currentNode[state.nodeKey]);
      } else {
        emit("update:modelValue", state.currentNode);
      }
    };

    watchEffect(() => {
      if (!props.modelValue) {
        state.currentNode = {};
        state.input = "";
      }
      if (props.type === "tree") {
        nextTick(() => {
          treeSelectRef.value.setCurrentKey(props.modelValue);
          const data = treeSelectRef.value.getCurrentNode(props.modelValue);
          currentChange(data);
        });
      } else if (props.type === "list") {
        for (const item of props.data) {
          if (item[state.nodeKey] === props.modelValue) {
            currentChange(item);
            break;
          }
        }
      }
    });
    return {
      ...refData,
      treeSelectRef,
      popoverRef,
      filterNode,
      currentChange
    };
  }
});
</script>
<style lang="scss" scoped>
.HSelect {
  position: relative;
  width: 100%;
}
.h-select-list-item {
  font-size: var(--el-font-size-base);
  padding: 0 32px 0 5px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--el-text-color-regular);
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: var(--el-bg-color);
  }
  &.selected {
    color: var(--el-color-primary);
    font-weight: 700;
  }
}
</style>
